<section class="park-section" [ngClass]="{'park-hours': parkHours}">
    <div class="header">
        <div class="title">
            <h3 class="text" *ngIf="parkHours">{{title}}</h3>
            <h4 class="text" *ngIf="!parkHours">{{title}}</h4>
            <ng-container *ngIf="!groups.length">
                <span class="subtitle">{{emptyHoursText}}</span>
                <finder-disclaimer [disclaimer]="labels.emptyHours?.disclaimer"></finder-disclaimer>
            </ng-container>
        </div>
        <finder-font-icon size="xl" *ngIf="parkHours && icon" [name]="icon"></finder-font-icon>
    </div>
    <ng-container *ngIf="permanentActivity">
        <div class="permanent-activity" *ngFor="let activity of permanentActivity">
            <finder-anchor
                class="name"
                *ngIf="activity.href; else noAnchor"
                [href]="activity.href"
                [linkId]="activity.linkId"
            >
                <strong>
                    {{activity.name}}
                </strong>
            </finder-anchor>
            <ng-template #noAnchor>
                <strong class="name">{{activity.name}}</strong>
                <span>{{activity.schedules}}</span>
            </ng-template>
        </div>
    </ng-container>
    <!-- Iterate over the Schedule groups -->
    <div class="hours-container">
        <div class="permanent-schedule" *ngIf="permanentSchedule">
            <strong class="type">{{permanentSchedule.type}}</strong>
            <span class="time">{{permanentSchedule.time}}</span>
        </div>
        <div class="hours" *ngFor="let group of groups">
            <finder-anchor
                class="name"
                *ngIf="group.href && showLinks; else noLink"
                ariaLabel="{{group.name}} - {{location.title}}"
                [href]="group.href">
                {{group.name}}
            </finder-anchor>
            <ng-template #noLink>
                <span class="name">{{group.name}}</span>
            </ng-template>
            <ng-container *ngIf="group?.schedules[formattedDate]">
                <span class="schedules" *ngFor="let schedule of group.schedules[formattedDate]">{{schedule.time}}</span>
            </ng-container>
        </div>
        <finder-button
            *ngIf="viewAll"
            class="link"
            anchor="true"
            ariaLabel="{{viewAll.text}} - {{title}} - {{location.title}}"
            (click)="onViewAll()">
            {{viewAll.text}}
            <finder-font-icon
                name="next"
                class="icon"
                size="xs">
            </finder-font-icon>
        </finder-button>
    </div>
    <!-- Iterate over the Blockouts groups (only for some HKDL locales) -->
    <div class="blockouts-container" *ngIf="type === 'operating' && isBlockoutEligible">
        <div class="title">
            {{labels.blockouts}}
        </div>
        <div class="blockouts" *ngIf="location.blockouts.length >= 1; else noBlockouts">
            <div *ngFor="let blockout of location.blockouts"
                [ngClass]="{'single': location.blockouts.length === 1}">
                <div class="name">{{blockout.name}}</div>
            </div>
        </div>
        <ng-template #noBlockouts>
            <finder-disclaimer [disclaimer]="noBlockoutsText"></finder-disclaimer>
        </ng-template>
    </div>
</section>
